export const PROMPT_STATUS_OPTIONS = [
  { label: "Activ", value: "active" },
  { label: "Inactiv", value: "inactive" },
  { label: "Arhivat", value: "archived" },
];

export const TEXT_VERBOSITY_OPTIONS = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
];

export const DEFAULT_NEW_PROMPT_DRAFT = Object.freeze({
  prompt_key: "",
  display_name: "",
  description: "",
  entity_type: "company",
  status: "active",
  profile_key: "enrich_research",
  provider_key: "openai",
  model_key: "gpt-5.5",
  reasoning_effort: "medium",
  text_verbosity: "low",
  timeout_ms: 45000,
  tool_config_text: JSON.stringify(
    {
      structured_outputs: true,
      web_search: false,
      retry_with_web_search_when_empty: true,
    },
    null,
    2
  ),
  output_schema_text: JSON.stringify(
    {
      type: "object",
      additionalProperties: false,
      properties: {
        field_suggestions: { type: "array" },
        missing_fields: { type: "array" },
        warnings: { type: "array" },
      },
    },
    null,
    2
  ),
  retry_policy_text: JSON.stringify({ max_attempts: 2, backoff_ms: 1200 }, null, 2),
  prompt_body: "",
  notes: "",
});

export const formatPromptJson = (value) => {
  if (!value) {
    return "{}";
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch (_) {
    return "{}";
  }
};

export const buildNewPromptDraft = () => ({ ...DEFAULT_NEW_PROMPT_DRAFT });

export const buildPromptDraft = (prompt) => ({
  prompt_key: prompt?.prompt_key || "",
  display_name: prompt?.display_name || "",
  description: prompt?.description || "",
  entity_type: prompt?.entity_type || "company",
  status: prompt?.status || "active",
  profile_key: prompt?.profile_key || "enrich_research",
  provider_key: prompt?.provider_key || "openai",
  model_key: prompt?.model_key || "gpt-5.5",
  reasoning_effort: prompt?.reasoning_effort || "medium",
  text_verbosity: prompt?.text_verbosity || "low",
  timeout_ms: prompt?.timeout_ms || 45000,
  tool_config_text: formatPromptJson(prompt?.tool_config_json),
  output_schema_text: formatPromptJson(prompt?.output_schema_json),
  retry_policy_text: formatPromptJson(prompt?.retry_policy_json),
  prompt_body: prompt?.prompt_body || "",
  notes: prompt?.notes || "",
});

export const parsePromptJsonField = (value, fieldLabel) => {
  const normalized = String(value || "").trim();
  if (!normalized) {
    return {};
  }
  try {
    return JSON.parse(normalized);
  } catch (_) {
    throw new Error(`${fieldLabel} trebuie să fie JSON valid.`);
  }
};

export const serializePromptDraft = (draft) => ({
  display_name: String(draft.display_name || "").trim(),
  description: String(draft.description || "").trim(),
  entity_type: String(draft.entity_type || "").trim(),
  status: draft.status,
  profile_key: draft.profile_key,
  provider_key: String(draft.provider_key || "").trim(),
  model_key: String(draft.model_key || "").trim(),
  reasoning_effort: draft.reasoning_effort,
  text_verbosity: draft.text_verbosity,
  timeout_ms: Number.parseInt(draft.timeout_ms, 10) || null,
  tool_config_json: parsePromptJsonField(draft.tool_config_text, "Tool config"),
  output_schema_json: parsePromptJsonField(draft.output_schema_text, "Output schema"),
  retry_policy_json: parsePromptJsonField(draft.retry_policy_text, "Retry policy"),
  prompt_body: String(draft.prompt_body || "").trim(),
  notes: String(draft.notes || "").trim(),
});
